import { z } from 'zod'

export const evidenceAcceptanceSchema = z.object({
  reason: z.string().max(2_000),
  changes: z.array(z.object({
    selected: z.boolean(),
    suggestedValue: z.string(),
    value: z.string().min(1, 'Enter an adopted value'),
  })),
}).superRefine((values, context) => {
  const selected = values.changes.filter((change) => change.selected)
  if (selected.length === 0) {
    context.addIssue({ code: 'custom', message: 'Select at least one suggestion', path: ['root'] })
  }
  if (selected.some((change) => change.value !== change.suggestedValue) && !values.reason.trim()) {
    context.addIssue({ code: 'custom', message: 'Explain changed values', path: ['reason'] })
  }
})

export const evidenceKeepSchema = z.object({
  reason: z.string().trim().min(1, 'Explain why you are keeping existing assumptions').max(2_000),
})
